<script setup lang="ts">
const {
  errorMessages = [],
  readonly = false,
  disabled = false,
  label = 'Password',
  placeholder = '',
  rounded = 'lg',
  bgColor = 'white',
  hideDetails = false,
} = defineProps<{
  errorMessages?: string | string[];
  readonly?: boolean;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  rounded?: string | number | boolean;
  bgColor?: string;
  hideDetails?: boolean | 'auto';
}>();

const password = defineModel<string>();

const showPassword = ref(false);
function togglePasswordVisibility() {
  showPassword.value = !showPassword.value;
}
</script>

<template>
  <v-text-field
    v-model="password"
    variant="solo"
    autocomplete="current-password"
    :error-messages="errorMessages"
    :rounded="rounded"
    :placeholder="placeholder"
    :label="label"
    :readonly="readonly"
    :disabled="disabled"
    :bg-color="bgColor"
    :type="showPassword ? 'text' : 'password'"
    data-testid="password"
    @blur="$emit('blur', $event)"
    :hide-details="hideDetails"
  >
    <template #append-inner>
      <slot name="append-inner">
        <v-icon data-testid="password-toggle" @click="togglePasswordVisibility">
          {{ showPassword ? 'mdi-eye' : 'mdi-eye-off' }}
        </v-icon>
      </slot>
    </template>
  </v-text-field>
</template>

<style scoped>
:deep(.v-label) {
  color: #414156 !important;
  opacity: 1 !important;
}

:deep(.v-input__control) {
  overflow: visible;
}

:deep(.v-field) {
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  box-shadow: none !important;
  overflow: visible;
}

:deep(.v-field--focused) {
  border-color: #414156 !important;
  background-color: #FFFCE9 !important;
}

:deep(.v-field--error) {
  border-color: rgb(var(--v-theme-error)) !important;
}

:deep(.v-field--error .v-field__outline),
:deep(.v-field__outline) {
  display: none;
}

:deep(.v-field__overlay) {
  display: none;
}
</style>
